type SectionType = Record<string, string>;

export type MessagesType = {
  ERRORS: SectionType;
  INFO: SectionType;
  TITLES: SectionType;
};

export const MESSAGES: MessagesType = {
  ERRORS: {},
  INFO: {
    REQUEST_PATENT_INFO_TOOLTIP:
      "By checking this box, you indicate your interest in including not just Companies but also potential Patents and Scientific Articles in your Golden Basket.",
  },
  TITLES: {},
};
